// settings/Modal.tsx
import React from "react";

interface ModalProps {
  open: boolean;
  onClose?: () => void;
  title?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  width?: number | string;
  variant?: "default" | "danger";
  closeOnOverlayClick?: boolean; 
}

const overlayStyle: React.CSSProperties = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.8)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};

const outerFrameStyle: React.CSSProperties = {
  borderRadius: 16,              // larger radius
  border: "4px solid #d4af37",      // thicker black frame
  overflow: "hidden",
};

const baseModalStyle: React.CSSProperties = {
  background: "#050a1c",
  color: "#ddd",
  padding: 32,                   // more padding
  maxWidth: "90vw",
};

const titleStyle: React.CSSProperties = {
  marginTop: 0,
  marginBottom: 12,
  fontSize: 22,
  fontWeight: 600,
  textAlign: "center",
  width: "100%",
};


const bodyStyle: React.CSSProperties = {
  margin: "10px 0 18px",
  fontSize: 15,                  // slightly larger text
  lineHeight: 1.6,
};

const footerStyle: React.CSSProperties = {
  display: "flex",
  gap: 10,
  justifyContent: "flex-end",
  marginTop: 10,
};

const bottomGoldBar: React.CSSProperties = {
  height: 3,                     // a bit taller
  width: "100%",
  background: "#000",         // gold
};

const Modal: React.FC<ModalProps> = ({
  open,
  onClose,
  title,
  children,
  footer,
  width = 520,                   // larger default width
  closeOnOverlayClick = true, // 👈 default behavior
}) => {
  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={overlayStyle}
      onClick={(e) => {
        if (!closeOnOverlayClick) return;
        if (e.target === e.currentTarget && onClose) onClose();
      }}
    >
      <div
        style={{ ...outerFrameStyle, width }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={baseModalStyle}>
          {title && <h3 style={titleStyle}>{title}</h3>}
          <div style={bodyStyle}>{children}</div>
          {footer && <div style={footerStyle}>{footer}</div>}
        </div>
        <div style={bottomGoldBar} />
      </div>
    </div>
  );
};

export default Modal;
